<template>
  <div class="chart-page">
    <div class="chart-toolbar">
      <div class="toolbar-row">
        <pods-input ref="podsInput" />
        <div class="toolbar-actions">
          <UtcOffsets />
        </div>
      </div>
    </div>
    <div class="app-card">
      <div id="chart" :style="{ width: '100%', height: '560px' }"></div>
    </div>
  </div>
</template>

<script>
import PodsInput from '@/components/PodsInput'
import moment from 'moment-timezone'
import UtcOffsets from '@/components/UtcOffsets'

export default {
  data() {
    return {
      moment,
      chart: '',
      options: {}
    }
  },
  props: {
    podData: {
      require: true,
      type: Array
    },
    screenWidth: {
      require: true,
      type: Number
    }
  },
  components: {
    PodsInput,
    UtcOffsets
  },
  watch: {
    podData() {
      if (this.chart) {
        this.chart.setOption({
          dataset: {
            source: this.getSourceData()
          }
        })
      }
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    getSourceData() {
      let data = [
        [
          'timeStampWithUtc',
          'sensor1Value',
          'sensor2Value',
          'ax',
          'ay',
          'az',
          'connectionStatus',
          'batteryVoltage',
          'temperature'
        ]
      ]
      this.podData.forEach(item => {
        data.push([
          item.timeStampWithUtc,
          item.sensor1Value,
          item.sensor2Value,
          item.ax,
          item.ay,
          item.az,
          item.connectionStatus,
          item.batteryVoltage,
          item.temperature
        ])
      })
      return data
    },
    initChart() {
      var dom = document.getElementById('chart')
      this.chart = this.echarts.init(dom)
      this.options = {
        grid: {
          left: 0,
          right: 20,
          bottom: 50,
          top: 20,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            let tooltipStr = `<div>${moment(params[0].axisValue).format(
              'DD/MM/YY HH:mm:ss'
            )}</div>`
            params.forEach(item => {
              if (tooltipStr.indexOf(item.color) < 0) {
                tooltipStr =
                  tooltipStr +
                  `<div><div style="display:inline-block; margin-right: 5px; width: 10px; height: 10px; border-radius: 5px; background-color:${
                    item.color
                  }"></div>${item.seriesName} : ${
                    item.value[item.seriesIndex + 1]
                  }</div>`
              }
            })
            return tooltipStr
          }
        },
        legend: {
          x: 'center',
          y: 'bottom',
          data: [
            'Sensor 1',
            'Sensor 2',
            'Ax',
            'Ay',
            'Az',
            'Connection Status',
            'Battery Voltage',
            'Temperature'
          ],
          selected: {
            Ax: false,
            Ay: false,
            Az: false,
            'Connection Status': false,
            'Battery Voltage': false,
            Temperature: false
          }
        },
        xAxis: [
          {
            type: 'time',
            boundaryGap: false,
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              showMinLabel: true,
              showMaxLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            nameLocation: 'center',
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: ['#f2f2f2'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        dataZoom: [
          {
            show: true,
            height: 25,
            bottom: 25,
            start: 0,
            zoomOnMouseWheel: true,
            moveOnMouseMove: true
          },
          {
            type: 'inside'
          }
        ],
        dataset: {
          dimensions: [
            'timeStampWithUtc',
            'sensor1Value',
            'sensor2Value',
            'ax',
            'ay',
            'az',
            'connectionStatus',
            'batteryVoltage',
            'temperature'
          ],
          source: this.getSourceData()
        },
        series: [
          {
            name: 'Sensor 1',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'sensor1Value'
            }
          },
          {
            name: 'Sensor 2',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'sensor2Value'
            }
          },
          {
            name: 'Ax',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'ax'
            }
          },
          {
            name: 'Ay',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'ay'
            }
          },
          {
            name: 'Az',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'az'
            }
          },
          {
            name: 'Connection Status',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'connectionStatus'
            }
          },
          {
            name: 'Battery Voltage',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'batteryVoltage'
            }
          },
          {
            name: 'Temperature',
            type: 'line',
            symbol: 'circle',
            smooth: true,
            encode: {
              x: 'timeStampWithUtc',
              y: 'temperature'
            }
          }
        ]
      }
      this.chart.setOption(this.options)
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    }
  },
  beforeDestroy() {
    if (this.chart) this.chart.clear()
  }
}
</script>
